const withFieldError = (errors, name, message) => {
    if (!message) {
        if (!(name in errors)) return errors;
        const next = { ...errors };
        delete next[name];
        return next;
    }
    if (errors[name] === message) return errors;
    return { ...errors, [name]: message };
};

export { withFieldError };
